module.exports = __webpack_public_path__ + "static/media/online class.b3b0c964.png";